import { useState, useCallback } from 'react';

/**
 * Custom hook to manage channel modal states
 * @returns {Object} Modal states and handlers
 */
const useChannelModals = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showAgentEditModal, setShowAgentEditModal] = useState(false);
    const [showCredentialEditModal, setShowCredentialEditModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState(null);

    const handleShowAdd = useCallback(() => {
        setShowAddModal(true);
        setShowAgentEditModal(false);
        setShowCredentialEditModal(false);
        setShowDetailsModal(false);
        setSelectedChannel(null);
    }, []);

    const handleShowAgentEdit = useCallback((channel) => {
        setSelectedChannel(channel);
        setShowAgentEditModal(true);
        setShowCredentialEditModal(false);
        setShowAddModal(false);
        setShowDetailsModal(false);
    }, []);

    const handleShowCredentialEdit = useCallback((channel) => {
        setSelectedChannel(channel);
        setShowCredentialEditModal(true);
        setShowAgentEditModal(false);
        setShowAddModal(false);
        setShowDetailsModal(false);
    }, []);

    const handleShowDetails = useCallback((channel) => {
        setSelectedChannel(channel);
        setShowDetailsModal(true);
        setShowAddModal(false);
        setShowAgentEditModal(false);
        setShowCredentialEditModal(false);
    }, []);

    const handleCloseModals = useCallback(() => {
        setShowAddModal(false);
        setShowAgentEditModal(false);
        setShowCredentialEditModal(false);
        setShowDetailsModal(false);
        setSelectedChannel(null);
    }, []);

    return {
        showAddModal,
        showAgentEditModal,
        showCredentialEditModal,
        showDetailsModal,
        selectedChannel,
        handleShowAdd,
        handleShowAgentEdit,
        handleShowCredentialEdit,
        handleShowDetails,
        handleCloseModals,
    };
};

export default useChannelModals;
